// hooks/useSurveyByCode.js
import { useQuery } from 'react-query'
import { gateway }  from '../utils/api'

export function useSurveyByCode (code, enabled = false) {
  return useQuery(
    ['survey', code],
    () => gateway.get(`/feedback/form/find/${code}`),
    { enabled }      
  )
}
